export const requiredText = (text) => {
  return `${text} *`
}
